import { createContext, useContext } from "react";

export type QuinnArtifactCanvas = {
    activeArtifactId: string | null;
    openArtifact: (artifactId: string) => void;
};

export const QuinnArtifactCanvasContext = createContext<QuinnArtifactCanvas | null>(null);

export function useQuinnArtifactCanvas(): QuinnArtifactCanvas | null {
    return useContext(QuinnArtifactCanvasContext);
}
